import React from "react"
import styled from "styled-components"

import {InjectIntl, injectIntl} from "@irati/utils/lang"

import NewItemStyles from "./styled/NewItem"

interface Props extends InjectIntl {
  text?: string
}

const NewItem = styled.div`
  ${NewItemStyles}
`

export default injectIntl<Props>(({text, formatMessage}) => (
  <NewItem>
    <span>{text || formatMessage({id: "recognition.feed.newItem"})}</span>
  </NewItem>
))
